/**
 * riskactions.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../actiontypes';
import {serviceURL, taskApiRoutes, annotationType, updateAction, referenceNumber} from '../../util/uiconstants';
import env from '../../util/env';

export const openAnnotationModal = (financialStatementId) => {
	return {
		type: types.OPEN_ANNOTATION_MODAL,
		financialStatementId
	};
};

export const clearAnnotationModal = () => {
	return {
		type: types.CLEAR_ANNOTATION_MODAL
	};
};

export const updateEntityAnnotation = (engagementId, annotation) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + taskApiRoutes.annotation;

	return {
		type: types.UPDATE_ENTITY_ANNOTATION,
		meta: {
			api: {
				url,
				method: 'PUT',
				data: {
					ids: [annotation.annotationId],
					comments: annotation.annotationText,
					updateAction: updateAction.editComment,
					referenceNumber: referenceNumber.one,
					financialStatementId: annotation.financialStatementId
				}
			}
		},
		annotation
	};
};

export const createEntityAnnotation = (engagementId, annotation) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + taskApiRoutes.annotation;

	return {
		type: types.CREATE_ENTITY_ANNOTATION,
		meta: {
			api: {
				url,
				method: 'POST',
				data: {
					financialStatementId: annotation.financialStatementId,
					fromUser: annotation.currentUser,
					comments: annotation.annotationText,
					annotationTypeId: annotationType.comment,
					referenceNumber: referenceNumber.one
				}
			}
		},
		annotation
	};
};

export const deleteEntityAnnotation = (engagementId, annotation) => {
	const url = env.getBaseURL(serviceURL, Number(engagementId)) + taskApiRoutes.annotation + annotation.annotationId;

	return {
		type: types.DELETE_ENTITY_ANNOTATION,
		meta: {
			api: {
				url,
				method: 'DELETE'
			}
		},
		annotation
	};
};
